<template>	   
	<v-container>
	  <material-card
	    class="card-tabs"
	    color="green"
	  	title="Calculadora de variables"
	    text="Cree formulas a partir de variables"
	    >
	    <v-card>
	      <v-card-title primary-title>
		      <v-layout row wrap>
        	  <v-flex xs6 pa-1>
        	    <label>Nombre de la formula</label>
            	<v-text-field
            	  name="name"
            	  label="Nombre de la formula" 
            	  id="name" v-model="formula.name" solo
            	></v-text-field>
        	  </v-flex>
        	  <v-flex xs6 pa-1>
							<label>Formula de nivel {{ formula.level }}</label>
							<v-checkbox label="Asiganar nulo a las variables no asignadas" v-model="formula.default_asignator"></v-checkbox>
        	  </v-flex>
        	</v-layout>
	      </v-card-title>
	      <div class="formula-container">
	      	<div v-if="!calculatorError.active">
        		<div :class="param != 'salto' ? 'item-form' : 'salto'" 
							v-for="(param, keyp) in formula.mask" :key="keyp"
							v-html="param != 'salto' ? param : '<br>'"></div>
        		<span  class="item-form cursor">|</span>
	      	</div>
	      	<div v-else>
	      		{{ calculatorError.message }}
	      	</div>
        </div>
	      <v-card-text>
	        <v-layout row wrap>
	          <v-flex xs6>
	            <div class="list-vars">
	            	<v-text-field
	            	  name="searchvar"
	            	  label="Buscar variable..." append-icon="mdi-magnify"
	            	  id="searchvar" v-model="search" solo
	            	></v-text-field>
	            	<v-list>
	            		 <v-list-item>
            	    	<v-list-item-action>
            	    		<v-btn text  small fab color="primary"  @click="addItem({value: formula.name})">
            	      		<v-icon>fas fa-plus</v-icon>
            	    		</v-btn>
            	    	</v-list-item-action>
	            	    <v-list-item-content>
	            	      <v-list-item-title>{{ formula.name }}</v-list-item-title>
	            	      <v-list-item-subtitle>
												Resultado de la ecuación
	            	      </v-list-item-subtitle>  
	            	    </v-list-item-content>
	            	    <v-list-item-action>
	            	      <v-icon>mdi-variable</v-icon>
	            	    </v-list-item-action>
	            	  </v-list-item>
            			<v-divider></v-divider>
	            		<div  v-ripple v-for="(variable, index) in filterVars" :key="variable.name + index">
		            	  <v-list-item>
	            	    	<v-list-item-action>
	            	    		<v-btn fab small text color="primary" @click="addItem(variable)">
	            	      		<v-icon>fas fa-plus</v-icon>
	            	    		</v-btn>
	            	    	</v-list-item-action>
		            	    <v-list-item-content>
		            	      <v-list-item-title>{{ variable.name }}</v-list-item-title>
		            	      <v-list-item-subtitle>
													{{ variable.category }} | {{ variable.type }}
		            	      </v-list-item-subtitle>
		            	    </v-list-item-content>
		            	    <v-list-item-action>
												<v-text-field
												  name="name" type="number"
												  label="Lag" v-model="variable.lag"
												  id="id"
												></v-text-field>
		            	    </v-list-item-action>
		            	  </v-list-item>
	            			<v-divider></v-divider>
	            		</div>
	            	</v-list>
	            </div>
	          </v-flex>
	          <v-flex xs6 pl-3>
	            <v-card >
	            	<v-card-text >
	            	  <v-layout row wrap>
	            	    <v-flex xs12>
	            	      <v-layout row wrap justify-center>
	            	      	<div v-for="(item, keyc) in buttons.conditionals.actions" :key="keyc">
		            	        <v-flex  class="text-md-center"
		            	        	:xs1="buttons.conditionals.xs1" :xs2="buttons.conditionals.xs2" :xs3="buttons.conditionals.xs3" 
		            	        	:xs4="buttons.conditionals.xs4" :xs5="buttons.conditionals.xs5" :xs6="buttons.conditionals.xs6" 
		            	        	:xs12="buttons.conditionals.xs12"
		            	          >
		            	          <v-btn color="success"  outlined small @click="addItem(item)"><v-icon>{{ item.icon }}</v-icon></v-btn>
		            	        </v-flex>
	            	      	</div>
	            	      </v-layout>
	            	    </v-flex>

	            	    <v-flex xs4 mt-4>
	            	      <v-layout row wrap>
	            	        <v-flex v-for="(item, keym) in buttons.math.actions" :key="keym"
	            	        	:xs1="buttons.math.xs1" :xs2="buttons.math.xs2" :xs3="buttons.math.xs3" 
	            	        	:xs4="buttons.math.xs4" :xs5="buttons.math.xs5" :xs6="buttons.math.xs6" 
	            	        	:xs12="buttons.math.xs12"
	            	          >
	            	          <v-btn color="blue" fab  text @click="addItem(item)"><v-icon>{{ item.icon }}</v-icon></v-btn>
	            	        </v-flex>
	            	      </v-layout>
	            	    </v-flex>
	            	    <v-flex xs8 mt-4>
	            	      <v-layout row wrap justify-center>
	            	        <v-flex v-for="(item, keyn) in buttons.numbers.actions" mt-4 :key="keyn"
	            	        	:xs1="buttons.numbers.xs1" :xs2="buttons.numbers.xs2" :xs3="buttons.numbers.xs3" 
	            	        	:xs4="buttons.numbers.xs4" :xs5="buttons.numbers.xs5" :xs6="buttons.numbers.xs6" 
	            	        	:xs12="buttons.numbers.xs12" text-center
	            	          >
	            	          <v-btn color="amber darken-3" outlined   @click="addItem(item)"><strong>{{ item.icon }}</strong></v-btn>
	            	        </v-flex>
	            	      </v-layout>
	            	    </v-flex>
	            	  </v-layout>
	            	</v-card-text>
	            </v-card>
	          </v-flex>
	          <v-divider></v-divider>
	          <v-flex xs12>
	            <v-textarea
	              name="description" solo
	              label="Descripcion de la formula"
	              id="id" v-model="formula.description"
	            ></v-textarea>
	          </v-flex>
	        </v-layout>
	      </v-card-text>
	      <v-card-actions>
	        <v-spacer></v-spacer>
	        <v-btn to="/admin/calculator" color="primary">Cancelar</v-btn>
	        <v-btn @click="store()" color="success">Guardar</v-btn>
	      </v-card-actions>
	    </v-card>
	  </material-card>
	</v-container>
</template>
<script>
	export default{
		created() {
			this.getForm();
			this.getVars();

		},
		mounted(){

		},
		props: [
			
		],
		data(){
			return {
				basePath: process.env.VUE_APP_URL + 'api/gis/',
				formula: {
					name: 'X',
					mask: [],
					param: [],
					description: '',
					level: 0,
					default_asignator: false,
					//maskArray: [],
				},
				calculatorError:{
					active:false,
					message: ''
				},
				buttons: {
					conditionals: {
						name: 'Condicionales',
						xs1: true, xs2: false, xs3: false, xs4: false, xs5: false, xs6: false, xs12: false, 
						actions: [
							{icon: 'Or', name: 'or', value: '||', type: 'condition'},
							{icon: 'And', name: 'and', value: '&&', type: 'condition'},
							{icon: '(', name: '(', value: '(', type: 'condition'},
							{icon: ')', name: ')', value: ')', type: 'condition'},
							{icon: 'if', name: 'if', value: 'if', type: 'condition'},
							{icon: 'else', name: 'else', value: 'else', type: 'condition'},
							{icon: 'fas fa-less-than-equal', name: 'Menor o igual', value: '<=', type: 'condition'},
							{icon: 'fas fa-less-than', name: 'Menor', value: '<', type: 'condition'},
							{icon: 'fas fa-not-equal', name: 'Diferente', value: '!=', type: 'condition'},
							{icon: 'fas fa-equals', name: 'Igual que', value: '==', type: 'condition'},
							{icon: 'fas fa-greater-than', name: 'Mayor', value: '>', type: 'condition'},
							{icon: 'fas fa-greater-than-equal', name: 'Mayor o igual', value: '>=', type: 'condition'},
							{icon: 'mdi-null', name: 'null', value: 'null', type: 'condition'},
							{icon: 'mdi-sigma', name: 'sumatoria', value: 'sigma', type: 'especial'},
							{icon: ':', name: 'rango', value: ':', type: 'especial'},
							{icon: 'fas fa-paragraph', name: 'tab', value: 'tab', type: 'text'},
							{icon: 'fas fa-arrow-right', name: 'enter', value: 'enter', type: 'text'},
						]
					},
					math: {
						name: 'Matematicas',
						xs1: false, xs2: false, xs3: false, xs4: false, xs5: false, xs6: true, xs12: false, 
						actions: [
							{icon: 'fas fa-backspace', name: 'Borrar', value: '<-', type:'math'},
							{icon: 'CE', name: 'Borrar todo', value: '< =', type:'math'},
							{icon: 'fas fa-times', name: 'Multiplicado', value: '*', type:'math'},
							{icon: 'fas fa-divide', name: 'Dividir', value: '/', type:'math'},
							{icon: 'fas fa-minus', name: 'Restar', value: '-', type:'math'},
							{icon: 'fas fa-plus', name: 'Sumar', value: '+', type:'math'},
							{icon: 'fas fa-percentage', name: 'Porcentaje', value: '%', type:'math'},
							{icon: 'fas fa-equals', name: 'Igual', value: '=', type:'math'},
						]
					},
					numbers: {
						name: 'Numbers',
						xs1: false, xs2: false, xs3: false, xs4: true, xs5: false, xs6: false, xs12: false, 
						actions: []
					},
				},
				ifelseActive: false,
				vars: [],
				search: '',
				response: '',
				interval: {},
				validators: {
					oParentActive: false,
					cParentActive: false,
					sigmaActive: false,
					rangeActive: false,
				},
				evalSigma: {
					params: [],
					active: false,
					initItem: 0,
					endItem: 0
				}
			}
		},
		methods: {
			getForm(){
				axios.get(this.basePath + 'formula/edit/' + this.$route.params.id).then((res) => {
					this.formula = res.data;
				});
			},
			getVars(){
				axios.get(this.basePath + 'variables/getSelect').then((res) => {
					this.vars = res.data;
				});
				for(let i = 1; i <= 9; i++) {
					this.buttons.numbers.actions.push({
						icon: i,
						value: i,
						name: i,
						type: 'number'
					});
				}
				this.buttons.numbers.actions.push({
					icon: ',',
					value: ',',
					name: ',',
					type: 'number'
				});
				this.buttons.numbers.actions.push({
					icon: 0,
					value: 0,
					name: 0,
					type: 'number'
				});
				this.buttons.numbers.actions.push({
					icon: '-',
					value: '-',
					name: '-',
					type: 'number'
				});
			},
			addItem(item){
				this.calculatorError = {
					active: false,
					message:''
				}
				
				if(item.value == '< ='){
					this.evalSigma = {
						params: [],
						active: false,
						initItem: 0,
						endItem: 0
					}
					this.validators.sigmaActive = false
					this.formula.param = [];
					this.formula.mask = [];
					this.formula.level = 0;
				}else if(item.value == '<-'){
 					this.formula.param = this.formula.param.slice(0,-1);
					this.formula.mask = this.formula.mask.slice(0,-1);
					this.evalSigma.params = this.evalSigma.params.slice(0,-1);
					var level = 0
					this.formula.param.map(function (item){
						if(level < item.level){
							level = item.level
						}
					})
					this.formula.level = level;
				}else if (item.type == 'math'){
					this.formula.param.push(item)
					this.formula.mask.push( ' <span class="math">' + item.value +'</span> ')
				}else if (item.type == 'number'){
					this.formula.param.push(item)
					this.formula.mask.push( '<span class="number">' + item.value +'</span>')
				}else if (item.type == 'condition'){
					this.formula.param.push(item)
					if(item.value == ')'){
						this.formula.mask.push( ' <span class="condition">' + item.value +'</span> ' )
						if(this.validators.sigmaActive){
							this.evalSigma.endItem = this.evalSigma.params.length - 1;
							this.asignateSigma();
							this.validators.sigmaActive = false
						}
					}else if(item.value == 'else'){
						this.formula.mask.push( ' <span class="condition">' + item.value +'</span> ')
					}else if(item.value == 'null'){
						this.formula.mask.push( '<span style="color: #6A0888" class="condition">' + item.value +'</span> ' )
					}else{
						this.formula.mask.push( '<span class="condition">' + item.value +'</span> ' )
					}
				}else if (item.type == 'text'){
					if(item.value == 'tab'){
						this.formula.param.push(' ')
						this.formula.mask.push('<pre class="tab">' + "     " +'</pre>')
					}else if (item.value == 'enter'){
						this.formula.param.push(' ')
						this.formula.mask.push('salto')
					}
				}else if (item.type == 'especial'){

					if(item.value == 'sigma'){
						this.formula.param.push(item)
						this.evalSigma.initItem = this.formula.param.length - 1; 
						this.formula.mask.push('<i style="color: red; font-size: 1.5em" class="v-icon mdi mdi-sigma"></i>')
						this.formula.mask.push(' <span class="condition"> (</span> ' )
						this.validators.sigmaActive = true
					}else if(item.value == ':'){
						if(this.validators.sigmaActive){
							this.formula.param.push(item)
							this.formula.mask.push( '<span class="math">' + item.value +'</span>')
							this.evalSigma.params.push(item);
						}
					}
				}else{
					var itemN = {
						id: item.id,
						level: item.level,
						name: item.name,
						value: item.value,
						category:item.category,
						type:item.type,
						lag: item.lag
					};
					if(item.level > this.formula.level){
						this.formula.level = item.level; 
					}
					if(item.lag != null && item.lag != 0){
						itemN.lag = itemN.lag.toString(); 
						this.formula.mask.push('<span class="var">' + item.value +'<small style="color: #4a4a4a; font-style: normal;">(lag' + item.lag+')</small></span> ')
					}else{
						this.formula.mask.push('<span class="var">' + item.value +'</span> ')
					}
					this.formula.param.push(itemN);
					if(this.validators.sigmaActive){
						this.evalSigma.params.push(itemN);
					}
				}
			},
			asignateSigma(){
				this.formula.param.splice(this.evalSigma.initItem, this.formula.param.length);
				this.formula.mask.splice(this.evalSigma.initItem, this.formula.mask.length);
				let firstParam = {}
				let lastParam = {}
				let counter = {first: 0, last: 0}
				let switchValue = true;
				for(var i in this.evalSigma.params){
					if(this.evalSigma.params[i].value == ':'){
						switchValue = false;
					}else	if(this.evalSigma.params[i].id != null && switchValue){
						counter.first++;
						firstParam = {
							variable: this.evalSigma.params[i].id,
							lag: parseInt(this.evalSigma.params[i].lag),
							object: this.evalSigma.params[i]
						}
					}else if(this.evalSigma.params[i].id != null){
						counter.last++;
						lastParam = {
							variable: this.evalSigma.params[i].id,
							lag:  parseInt(this.evalSigma.params[i].lag),
							object: this.evalSigma.params[i]
						}
					}
				}
				let boolValid =	(counter.first == 1 && counter.last == 1) 	&&
													(firstParam.variable == lastParam.variable)	&&
													(firstParam.lag < lastParam.lag)
				if(switchValue || !boolValid){
					this.calculatorError = {
						active: true,
						message: 'ERROR DE SYNTAXIS RANGO DE SUMATORIA NO VALIDO '
					}
				}else{
					let sumat = {icon: 'fas fa-plus', name: 'Sumar', value: '+', type:'math'}
					for(var it = firstParam.lag; it < lastParam.lag; it++){
						var item = {
							id: firstParam.object.id,
							level: firstParam.object.level,
							name: firstParam.object.name,
							value: firstParam.object.value,
							category:firstParam.object.category,
							type:firstParam.object.type,
							lag: it,
						};
						this.addItem(item);
						if(it < lastParam.lag - 1){
							this.addItem(sumat);
						}
					}
				}
			
				this.evalSigma = {
					params: [],
					active: false,
					initItem: 0,
					endItem: 0
				}
			},
			store(){
				var level = 0
				this.formula.param.map(function (item){
					if(level < item.level){
						level = item.level
					}
				})
				this.formula.level = level;
				axios.put(this.basePath + 'formula/update', this.formula).then((res) => {
					if(res.data == "Exito"){
						this.$router.push('/admin/calculator');
					}
				}).catch((error) => {
					this.response = error.data
				});
			}
		},
		watch: {

		},
		computed: {
			filterVars: function(){
				if(this.search != ''){
					let search = this.search;
					return this.vars.filter(function(item){
						return item.name.toLowerCase().includes(search.toLowerCase());
					});					
				}else{
					return this.vars;
				}
			}
		},
	}
</script>
<style>
	.formula-container{
		padding: 8px;
		color:white;
		width: 100%;
		font-size: 1.2em;
		height: 100px;
		background-color: #bababa;
		overflow: auto;
		border: solid black 1px;
	}
	.list-vars{
		position: relative;
		float:left;
		border: 1px #bababa solid;
		overflow: auto;
		width: 100%;
		height: 500px;
		padding: 5px;
	}
	.number{
		color: #6A0888;
	}
	.salto{
		position: relative;
		float: left;
		height: 1px;
		width: 100%;
	}
	.condition {
		color: red;
		font-size: 0.9em;
		margin: 1px;
		font-family: 'Source Code Pro';
	}
	.math{
		padding: 1px;
		margin: 1px;

		color: red;
	}
	.var{
		font-style: italic;

	}
	.item-form{
		margin-top:2px;
		position: relative;
		float: left;
	}
	.cursor{
		color: transparent; 
		animation: blink 1s infinite ;
	}
	@keyframes blink {
		from {
			border-left: solid 1px black;
			
		}
		to {
			border-left: solid 0px black;
			
		}
	}
</style>